import React from 'react';
import versionInfo from './version.json';
import clsx from 'clsx';

const Version = props => {
  const { mode, sidebarTheme = {} } = props;
  return (
    <>
      {mode !== 'sidebar' ? (
        <>
          <div
            className={clsx(
              'text-center  mt-2 text-opacity-60',
              sidebarTheme.navItemTextColor || 'text-gray-800'
            )}>
            {versionInfo.portalName}
          </div>
          <div
            className={clsx(
              'text-center text-xs mt-2',
              sidebarTheme.navItemTextColor || 'text-gray-800 '
            )}>
            Version {versionInfo.version} ({versionInfo.commit?.substring(0, 7)}
            )
          </div>
        </>
      ) : (
        <>
          <div
            className={clsx(
              'text-center text-xs mt-2 text-opacity-60',
              sidebarTheme.navItemTextColor || 'text-white'
            )}>
            v{versionInfo.version}
          </div>
          <div
            className={clsx(
              'text-center text-xs mt-2 text-opacity-60',
              sidebarTheme.navItemTextColor || 'text-white'
            )}>
            {versionInfo.commit?.substring(0, 7)}
          </div>
          <div
            className={clsx(
              'text-center text-xs mt-2 text-opacity-60',
              sidebarTheme.navItemTextColor || 'text-white'
            )}>
            {versionInfo.portalName}
          </div>
        </>
      )}
    </>
  );
};

export default Version;
